const defaultState = {
    orientation: 'manual',//auto
    layout: 'horizontal', //vertical
    mode: 'dices', //or dices,
    playersModal: false,
    route: 'board',// or stats
    theme: 'default'
}

export default function reducer(state = defaultState, action)
{

    switch (action.type) {

        case "SETTINGS_CHANGE_ORIENTATION": {
            return {
                ...state,
                orientation: action.payload.orientation
            }
        }
        case "SETTINGS_CHANGE_LAYOUT": {
            return {
                ...state,
                layout: action.payload.layout
            }
        }
        case "SETTINGS_CHANGE_MODE": {
            return {
                ...state,
                mode: action.payload.mode
            }
        }
        case "SETTINGS_TOGGLE_PLAYER_MODAL": {
            return {
                ...state,
                playersModal: action.payload.modal
            }
        }
        case "SETTINGS_CHANGE_ROUTE": {
            return {
                ...state,
                route: action.payload.route
            }
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/game/config/settings/reducer.js